export default __webpack_public_path__ + "static/media/image.8b5862f1.png";